// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".err[data-v-3e94274a] {\n  color: #c14e4e;\n}", ""]);
// Exports
module.exports = exports;
